import React from 'react'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/shadcn/tooltip'
import { cn } from '@/lib/utils'

interface TooltipButtonProps {
  children: React.ReactNode
  tooltip: React.ReactNode
  className?: string
  contentClassName?: string
  side?: 'top' | 'bottom' | 'left' | 'right'
  disabled?: boolean
}

/**
 * TooltipButton - A reusable component that wraps any element with a tooltip
 *
 * @param children - The element to wrap with a tooltip (usually a button)
 * @param tooltip - The tooltip text to display
 * @param className - Optional className for the wrapper
 * @param contentClassName - Optional className for the tooltip content
 * @param side - Optional side of the tooltip
 */
export function TooltipButton({
  children,
  tooltip,
  className,
  contentClassName,
  side,
  disabled = false,
}: TooltipButtonProps) {
  return (
    <Tooltip open={disabled ? false : undefined}>
      <TooltipTrigger asChild className={cn(className)}>
        {children}
      </TooltipTrigger>
      {!disabled && (
        <TooltipContent side={side} className={cn('bg-foreground text-xs text-offwhite', contentClassName)}>
          {tooltip}
        </TooltipContent>
      )}
    </Tooltip>
  )
}
